import { inject, Injectable } from '@angular/core';
import { CanActivate, GuardResult, MaybeAsync, Router } from '@angular/router';
import { SplashService } from '@context/frontend/common';
import { AuthService } from '../services';

/**
 * Only allows access to the select-organization page when the user is a super
 * admin with no organization selected. Otherwise redirects to home.
 */
@Injectable({ providedIn: 'root' })
export class SelectOrganizationAccessGuard implements CanActivate {
	private readonly authService = inject(AuthService);
	private readonly router = inject(Router);
	private readonly splash = inject(SplashService);

	canActivate(): MaybeAsync<GuardResult> {
		const authUser = this.authService.authUser;
		if (!authUser) return this.redirect();

		const isSuper = authUser.role === 'super';
		if (isSuper) return this.approve(); // good to go

		const hasOrg = !!this.authService.organization();
		if (hasOrg) return this.redirect();

		if (authUser.users.length > 1) return this.approve();
		return false;
	}

	readonly redirect = (): Promise<GuardResult> =>
		this.router.navigate(['/home']).then(() => false);

	readonly approve = (): boolean => {
		this.splash.onHide();
		return true;
	};
}
